import moment, { Moment } from "moment";
import { Evento, IEvento } from "./evento";
import PosicaoAtivo from "./posicaoAtivo";

export interface IEventoCarteira extends IEvento {
  acao: string;
  dataEvento: Moment;
  posicaoEx: PosicaoAtivo;
  fracao?: number;
}

export class EventoCarteira extends Evento implements IEventoCarteira {
  public acao!: string;
  public dataEvento!: Moment;
  public posicaoEx!: PosicaoAtivo;
  public fracao?: number;

  constructor(param: IEventoCarteira) {
    super(param);
    Object.assign(this, param);
  }

  static fromFirestore(obj: any): EventoCarteira {
    return new EventoCarteira({
      ...Evento.fromFirestore(obj),
      acao: obj.acao,
      fracao: obj.fracao,
      dataEvento: moment(obj.dataEvento.toDate()),
      posicaoEx: PosicaoAtivo.fromFirestore(obj.posicaoEx),
    });
  }
}
